import { useEffect, useState, type Dispatch, type SetStateAction } from "react";

// ui
import {
  Box,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";

// Table
import { ConstTable } from "../component/Table";

// Bar
import TableTopBar from "../component/TableTopBar";
import SerchSideBar from "../component/SerchSideBar";
import AiChatSideBar from "../component/AiChatSideBar";

// Modal
import { DataDetailModal } from "../component/detail/DataDetailModal";
import { DataEditModal } from "../component/DataEditModal";
import { DataAddModal } from "../component/DataAddModal";
import { DataAddModalResult } from "../component/DataAddModalResult";
import { PostCSVModal } from "../component/PostCSVModal";
import { ProductEditModal } from "../component/ProductEditModal";
import { DataDeleteModal } from "../component/tableFunction/DataDeleteModal";
import { FormOptionsEditModal } from "../component/tableFunction/FormOptionsEditModal";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getTossUpForms,
  getTossUpForm,
  postTossUpForm,
  putTossUpForm,
  deleteTossUpForm,
  postTossUpFormOptions,
  deleteTossUpFormOptions,
  getTossUpFormDeleteOptionNames,
} from "../api/tossUpForm";
import {
  getTossUpFormOptions,
  putTossUpFormOptions,
  getTossUpFormOption,
} from "../api/tossUpFormOption";
import { getTossUpFormOptionSelects } from "../api/tossUpFormOptionSelect";
import { getTossUpFormOptionDependProducts } from "../api/tossUpFormOptionDependProduct";
import { getTossUpFormOptionDependSelects } from "../api/tossUpFormOptionDependSelect";
import {
  getTossUpFormChatApps,
  getTossUpFormChatApp,
  putTossUpFormChatApp,
  postTossUpFormChatApp,
  deleteTossUpFormChatApp,
} from "../api/tossUpFormChatApp";
import {
  getTossUpFormChatAppDependSelects,
  postTossUpFormChatAppDependSelect,
  deleteTossUpFormChatAppDependSelect,
  getTossUpFormOptionsForChatAppDepend,
} from "../api/tossUpFormChatAppDependSelect";
import { getPresignedPostCSV, postPresignedPost } from "../api/presignedURL";
import {
  getSerchHighRankCompanys,
  getSerchCategorys,
  getSerchProducts,
  getSerchSaleCompanys,
} from "../api/serch";

// InterFace
import { tossUpFormTableColumn } from "../config/tossUpForm";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";

const postCSVColumnTossUpFormOption = [
  "カテゴリ",
  "トスアップパートナー",
  "質問名",
  "チャットアプリ連携",
  "必須フラグ",
  "質問区分",
  "デフォルト値",
  "入力値の編集",
  "説明",
  "フラグ設定",
  "依存商材名1",
  "依存商材名2",
  "、",
  "依存商材名5",
  "依存質問名",
  "依存選択肢1",
  "依存選択肢2",
  "、",
  "依存選択肢5",
  "選択肢1",
  "選択肢2",
  "、",
  "選択肢20",
];

const postCSVColumnTossUpFormOptionResult = [
  "カテゴリ",
  "トスアップパートナー",
  "質問名",
  "チャットアプリ連携",
  "必須フラグ",
  "質問区分",
  "デフォルト値",
  "入力値の編集",
  "説明",
  "フラグ設定",
];

function TossUpForm() {
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "トスアップフォーム登録",
    },
  ];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "質問登録CSV取込",
    },
  ];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {
    if (addDataName === "トスアップフォーム登録") {
      setTossUpFormAddModal(true);
    }
  }, [addDataName]);

  useEffect(() => {
    if (addCSVDataName === "質問登録CSV取込") {
      setPostTossUpFormOptionCSVStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
  }, [addCSVDataName]);

  useEffect(() => {
    if (editDatasName === "質問追加・削除") {
      setEditFormsStatus({
        ...editFormsStatus,
        status: "open",
      });
    }
  }, [editDatasName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubTableName.name === "質問一覧") {
      getSubtableDataOption();
    }
    if (getSubTableName.name === "チャットアプリ連携一覧") {
      getSubtableDataChatApp();
    }
  }, [getSubTableName.name, getSubTableName.key]);

  // サブテーブルデータの詳細取得
  const [getSubTableDetail, setGetSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({
    name: "",
    key: {},
    dataDetail: null,
  });
  useEffect(() => {
    if (getSubTableDetail.name === "チャットアプリ連携詳細") {
      getDataDetailTossUpFormChatApp();
    }
  }, [getSubTableDetail.name, getSubTableDetail.key]);

  // サブテーブルの一覧をメインテーブルの詳細表示（トスアップフォーム用）
  const [getSubMainTableDetail, setGetSubMainTableName] = useState<{
    name: string;
    key: { [key: string]: string };
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (getSubMainTableDetail.name === "質問一覧 詳細 / 編集") {
      getDataDetailTossUpFormOptionsMain(false);
    }
  }, [getSubMainTableDetail.name, getSubMainTableDetail.key]);

  // サブテーブルデータの登録
  const [getSubTableAdd, setGetSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {
    if (getSubTableAdd.name === "チャットアプリ連携追加") {
      setChatAppAddModal(true);
      setAddChatApp({
        ...addChatAppColumns,
        toss_up_form_id: getSubTableAdd.row?.id?.toString() || "",
      });
    }
  }, [getSubTableAdd.name, getSubTableAdd.row]);

  // サブサブテーブルデータの一覧取得
  const [getSubSubTableName, setGetSubSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  const [getSubSubTableDetail, setGetSubSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({ name: "", key: {}, dataDetail: null });
  useEffect(() => {
    if (getSubSubTableName.name === "選択肢一覧") {
      getSubSubtableDataSelect();
    }
    if (getSubSubTableName.name === "依存商材一覧") {
      getSubSubtableDataDependProduct();
    }
    if (getSubSubTableName.name === "依存質問-選択肢一覧") {
      getSubSubtableDataDependSelect();
    }
    if (getSubSubTableName.name === "チャット連携-依存質問-選択肢一覧") {
      getSubSubtableDataTossUpFormChatAppDependSelect();
    }
  }, [getSubSubTableName.name, getSubSubTableName.key]);

  // テーブル関数
  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
    subTableColumnName?: string;
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (
      tableOriginalFunc.name === "削除" &&
      tableOriginalFunc.subTableColumnName ===
        "チャット連携-依存質問-選択肢一覧"
    ) {
      setDeleteChatAppDependSelectInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    } else if (
      tableOriginalFunc.name === "削除" &&
      tableOriginalFunc.subTableColumnName === "チャットアプリ連携一覧"
    ) {
      setDeleteChatAppInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    } else if (tableOriginalFunc.name === "削除") {
      setDeleteDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
  }, [
    tableOriginalFunc.name,
    tableOriginalFunc.key,
    tableOriginalFunc.subTableColumnName,
  ]);

  // 検索欄、テーブル等の高さ
  const [tableHeight, setTableHeight] = useState("calc(100vh - 110px)");
  useEffect(() => {
    const tableHeight = isSmartPhone
      ? "calc(100vh - 190px)"
      : "calc(100vh - 110px)";
    setTableHeight(tableHeight);
  }, [isSmartPhone]);
  const [serchOpen, setSerchOpen] = useState(false);
  const [aiChatOpen, setAiChatOpen] = useState(false);

  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);

  // 検索項目
  const serchColumn = tossUpFormTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.serch === true) {
        if (difine.serchType === "date") {
          return {
            ...column,
            [difine.key + "_start"]: "",
            [difine.key + "_end"]: "",
          };
        } else if (difine.serchType === "payment_year_month") {
          return {
            ...column,
            payment_year: thisYear.toString(),
            payment_month: thisMonth.toString(),
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {},
  );
  const [serchString, setSerchString] = useState(serchColumn);
  const [serchStringView, setSerchStringView] = useState(serchColumn);

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getTossUpForms({
      ...serchString,
      displayNumber,
      pageNumber,
    });
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.tossUpForms);
      const countTossUpForms = Number(fetchData.countTossUpForms);
      setTotalCount(countTossUpForms);
      setMaxPageNumber(Math.ceil(countTossUpForms / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getTableData(false);
  }, [serchString, displayNumber, pageNumber]);

  // トスアップフォーム詳細
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string | { [key: string]: string | number }[];
  } | null>(null);

  async function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = key.id;
    const dataDetail = await getTossUpForm(id);
    setDataDetail(dataDetail);
    if (!edit) {
      setIsLoading(false);
    }
  }

  // トスアップフォーム編集
  const [editData, setEditData] = useState<EditDataDifine | null>(null);
  async function putEditData() {
    if (editData !== null) {
      setIsLoading(true);
      const id = editData.tableId as string;
      setEditData({
        ...editData,
        status: "editing",
      });
      const putResponce = await putTossUpForm(editData);
      await getDataDetail({ id }, true);
      await getTableData(true);
      setEditData({
        ...editData,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // トスアップフォーム新規作成
  const addTossUpFormColumns = tossUpFormTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.add) {
        return {
          ...column,
          [difine.key]: "",
        };
      } else {
        return {
          ...column,
        };
      }
    },
    {},
  );
  const [onDataAddModalResult, setOnDataAddModalResult] = useState("");
  const [addTossUpForm, setAddTossUpForm] = useState<{
    [key: string]: string | boolean | any[];
  }>(addTossUpFormColumns);
  const [onTossUpFormAddModal, setTossUpFormAddModal] = useState(false);
  async function postAddTossUpForm() {
    setIsLoading(true);
    setTossUpFormAddModal(false);
    const postResponce = await postTossUpForm(addTossUpForm);
    if (postResponce === "success") {
      await getTableData(false);
      setAddTossUpForm(addTossUpFormColumns);
      setOnDataAddModalResult("success");
    } else {
      setTossUpFormAddModal(true);
      setOnDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 質問一覧詳細（メインテーブル）
  const [dataDetailTossUpFormOptionsMain, setDataDetailTossUpFormOptionsMain] =
    useState<{
      [key: string]: number | string | { [key: string]: string | number }[];
    } | null>(null);
  async function getDataDetailTossUpFormOptionsMain(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = getSubMainTableDetail.key.id;
    const { detail_data, option_data } = await getTossUpFormOption(id);
    setDataDetailTossUpFormOptionsMain({
      ...detail_data,
      option_data,
    });
    if (!edit) {
      setIsLoading(false);
    }
  }

  // 質問一覧編集
  const [editTossUpFormOption, setEditTossUpFormOption] = useState<{
    [key: string]: any;
  } | null>(null);
  const [editTossUpFormOptionProducts, setEditTossUpFormOptionProducts] =
    useState<
      {
        high_rank_company_name: string;
        product_id: number;
        product_name: string;
      }[]
    >([]);
  async function putEditTossUpFormOption() {
    if (editTossUpFormOption !== null) {
      const id = editTossUpFormOption.tableId as string;
      setIsLoading(true);
      setEditTossUpFormOption({
        ...editTossUpFormOption,
        status: "editing",
      });
      const putResult = await putTossUpFormOptions(editTossUpFormOption);
      if (putResult?.edit == "success") {
        if (getSubTableName.key.id && getSubTableName.name === "質問一覧") {
          await getSubtableDataOption();
        }
        if (getSubTableName.key.id && getSubTableName.name === "チャットアプリ連携一覧") {
          await getSubtableDataChatApp();
        }
        if (getSubSubTableName.key.id && getSubSubTableName.name === "チャット連携-依存質問-選択肢一覧") {
          await getSubSubtableDataTossUpFormChatAppDependSelect();
        }
        setIsLoading(true);
        await getDataDetailTossUpFormOptionsMain(true);
        await getTableData(true);
      }
      setEditTossUpFormOption({
        ...editTossUpFormOption,
        status: putResult?.warning || putResult?.edit,
      });
      setIsLoading(false);
    }
  }

  // トスアップフォーム一括編集
  const [editFormsStatus, setEditFormsStatus] = useState<{
    status:
      | "none"
      | "open"
      | "add"
      | "delete"
      | "success"
      | "loading"
      | "add_error"
      | "delete_error";
    message: string;
    editIDs: number[];
    action: null | 0 | 1;
    delete_option_names: string[];
    select_option: {
      option_name: string;
      outside_form_display: 0 | 1;
      sns_send: 0 | 1;
      required_optional: 0 | 1;
      option_type: 0 | 1 | 2 | 3 | 4;
      option_default_value: string;
      change_value_conf: 0 | 1;
      option_comment: string;
      tel_flg: 0 | 1;
      name_flg: 0 | 1;
      company_name_flg: 0 | 1;
      zip_code_flg: 0 | 1;
      address_flg: 0 | 1;
      space_flg: 0 | 1;
      mail_address_flg: 0 | 1;
      form_tel_flg: 0 | 1;
      multi_text_flg: 0 | 1;
      contract_number_flg: 0 | 1;
      half_width_number_flg: 0 | 1;
      option_select: string[];
    };
  }>({
    status: "none",
    message: "",
    editIDs: [],
    action: null,
    delete_option_names: [],
    select_option: {
      option_name: "",
      outside_form_display: 0,
      sns_send: 1,
      required_optional: 0,
      option_type: 0,
      option_default_value: "",
      change_value_conf: 0,
      option_comment: "",
      tel_flg: 0,
      name_flg: 0,
      company_name_flg: 0,
      zip_code_flg: 0,
      address_flg: 0,
      space_flg: 0,
      mail_address_flg: 0,
      form_tel_flg: 0,
      multi_text_flg: 0,
      contract_number_flg: 0,
      half_width_number_flg: 0,
      option_select: [""],
    },
  });
  useEffect(() => {
    if (editFormsStatus.status === "loading") {
      setIsLoading(true);
    } else if (editFormsStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [editFormsStatus]);
  const [editFormOptionNames, setEditFormOptionNames] = useState<string[]>([]);
  async function getEditFormDeleteOptionNames() {
    setEditFormsStatus({
      ...editFormsStatus,
      status: "loading",
    });
    const optionName = await getTossUpFormDeleteOptionNames(
      editFormsStatus.editIDs,
    );
    if (optionName.length > 0) {
      setEditFormsStatus({
        ...editFormsStatus,
        status: "delete",
      });
      let editFormOptionNames: string[] = [];
      optionName.map((option) => {
        editFormOptionNames.push(option.option_name);
      });
      setEditFormOptionNames(editFormOptionNames);
    } else {
      setEditFormsStatus({
        ...editFormsStatus,
        status: "delete_error",
        message: "選択したフォームに共通の質問が存在しません。",
      });
    }
  }

  async function postEditFormOption() {
    setEditFormsStatus({
      ...editFormsStatus,
      status: "loading",
    });
    const responce = await postTossUpFormOptions(
      editFormsStatus.editIDs,
      editFormsStatus.select_option,
    );
    if (responce == "success") {
      if (getSubTableName.name === "質問一覧") {
        await getSubtableDataOption();
      }
      setEditFormsStatus({
        ...editFormsStatus,
        status: "success",
      });
    } else {
      setEditFormsStatus({
        ...editFormsStatus,
        status: "add_error",
        message: responce,
      });
    }
  }

  async function deleteEditFormOption() {
    setEditFormsStatus({
      ...editFormsStatus,
      status: "loading",
    });
    const responce = await deleteTossUpFormOptions(
      editFormsStatus.editIDs,
      editFormsStatus.delete_option_names,
    );
    if (responce == "success") {
      if (getSubTableName.name === "質問一覧") {
        await getSubtableDataOption();
      }
      setEditFormsStatus({
        ...editFormsStatus,
        status: "success",
      });
    } else {
      setEditFormsStatus({
        ...editFormsStatus,
        status: "delete_error",
        message: responce,
      });
    }
  }
  // 質問登録CSV取込
  const [postTossUpFormOptionCSVStatus, setPostTossUpFormOptionCSVStatus] =
    useState<{
      status: "none" | "open" | "posting" | "result" | "loading" | "error";
      message: string;
      result: { [key: string]: any }[];
      header_location: string;
    }>({
      status: "none",
      message: "",
      result: [],
      header_location: "None",
    });
  useEffect(() => {
    if (postTossUpFormOptionCSVStatus.status === "loading") {
      setIsLoading(true);
    } else if (postTossUpFormOptionCSVStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [postTossUpFormOptionCSVStatus]);
  async function postProductsCSV(postDatas: File) {
    setPostTossUpFormOptionCSVStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostTossUpFormOptionCSVStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "tossUpFormOption";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostTossUpFormOptionCSVStatus({
          status: "loading",
          message: "CSV取込完了",
          result: postTossUpFormOptionCSVStatus.result,
          header_location: decodedData.header_location,
        });
        // await getProductList();
        if (getSubTableName.key.id) {
          await getSubtableDataOption();
        }
        await getTableData(false);
        setPostTossUpFormOptionCSVStatus({
          status: "result",
          message: "CSV取込完了",
          result: postTossUpFormOptionCSVStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostTossUpFormOptionCSVStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postTossUpFormOptionCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostTossUpFormOptionCSVStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // サブテーブルデータの登録結果（共通）
  const [onSubtableDataAddModalResult, setOnSubtableDataAddModalResult] =
    useState("");

  // 質問一覧取得
  async function getSubtableDataOption() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getTossUpFormOptions(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // チャットアプリ連携一覧取得
  async function getSubtableDataChatApp() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getTossUpFormChatApps(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // チャットアプリ連携詳細取得
  const [dataDetailChatApp, setDataDetailChatApp] = useState<{
    [key: string]:
      | number
      | string
      | { [key: string]: string | number }[]
      | { [key: string]: string | string[] };
  } | null>(null);
  async function getDataDetailTossUpFormChatApp() {
    setIsLoading(true);
    const id = getSubTableDetail.key.id;
    const dataDetail = await getTossUpFormChatApp(id);
    setGetSubTableDetail({
      ...getSubTableDetail,
      dataDetail: dataDetail,
    });
    setDataDetailChatApp(dataDetail);
    setIsLoading(false);
  }

  // チャットアプリ連携編集
  const [editChatAppData, setEditChatAppData] = useState<EditDataDifine | null>(
    null,
  );
  async function putEditChatAppData() {
    if (editChatAppData !== null) {
      setIsLoading(true);
      const id = editChatAppData.tableId as string;
      setEditChatAppData({
        ...editChatAppData,
        status: "editing",
      });
      const putResponce = await putTossUpFormChatApp(editChatAppData);
      await getDataDetailTossUpFormChatApp();
      await getSubtableDataChatApp();
      await getTableData(true);
      setEditChatAppData({
        ...editChatAppData,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // チャットアプリ連携新規作成
  const addChatAppColumns =
    tossUpFormTableColumn.subTable[0].subDataColumn.reduce((column, difine) => {
      if (difine.add) {
        return {
          ...column,
          [difine.key]: "",
        };
      } else {
        return {
          ...column,
        };
      }
    }, {});
  const [onChatAppAddModalResult, setOnChatAppAddModalResult] = useState("");
  const [addChatApp, setAddChatApp] = useState<{
    [key: string]: string | boolean | any[];
  }>(addChatAppColumns);
  const [onChatAppAddModal, setChatAppAddModal] = useState(false);
  async function postAddChatApp() {
    setIsLoading(true);
    setChatAppAddModal(false);
    const postResponce = await postTossUpFormChatApp(addChatApp);
    if (postResponce === "success") {
      await getSubtableDataChatApp();
      await getTableData(true);
      setAddChatApp(addChatAppColumns);
      setOnChatAppAddModalResult("success");
    } else {
      setChatAppAddModal(true);
      setOnChatAppAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // チャットアプリ連携削除
  const [deleteChatAppInf, setDeleteChatAppInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deleteChatAppData() {
    setDeleteChatAppInf({
      ...deleteChatAppInf,
      status: "loading",
    });
    const id = deleteChatAppInf.key.id;
    const responce = await deleteTossUpFormChatApp(id);
    if (responce == "success") {
      await getSubtableDataChatApp();
      await getTableData(true);
      setDeleteChatAppInf({
        ...deleteChatAppInf,
        status: "success",
      });
    } else {
      setDeleteChatAppInf({
        ...deleteChatAppInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteChatAppInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteChatAppInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteChatAppInf]);

  // トスアップフォーム - 質問一覧取得
  async function getSubSubtableDataSelect() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getTossUpFormOptionSelects(
        getSubSubTableName.key.id,
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // トスアップフォーム - 依存商材一覧取得
  async function getSubSubtableDataDependProduct() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getTossUpFormOptionDependProducts(
        getSubSubTableName.key.id,
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // トスアップフォーム - 依存質問-選択肢一覧取得
  async function getSubSubtableDataDependSelect() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getTossUpFormOptionDependSelects(
        getSubSubTableName.key.id,
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // トスアップフォーム - チャット連携-依存質問-選択肢一覧取得
  async function getSubSubtableDataTossUpFormChatAppDependSelect() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getTossUpFormChatAppDependSelects(
        getSubSubTableName.key.id,
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // チャット連携-依存質問-選択肢 追加用
  const [onChatAppDependSelectAddModal, setOnChatAppDependSelectAddModal] =
    useState(false);
  const [
    onChatAppDependSelectAddModalResult,
    setOnChatAppDependSelectAddModalResult,
  ] = useState("");
  const [addChatAppDependSelect, setAddChatAppDependSelect] = useState<{
    toss_up_form_chat_app_id: string;
    option_id: string;
    toss_up_form_option_select_id: string;
  }>({
    toss_up_form_chat_app_id: "",
    option_id: "",
    toss_up_form_option_select_id: "",
  });
  const [
    tossUpFormOptionsForChatAppDependFull,
    setTossUpFormOptionsForChatAppDependFull,
  ] = useState<
    {
      option_id: number;
      option_name: string;
      option_selects: { id: number; option_select: string }[];
    }[]
  >([]);
  const chatAppDependSelectAddSubDataColumn = [
    {
      key: "option_id",
      name: "質問",
      table: false,
      tableValue: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "list" as const,
      addMessage: "",
    },
    {
      key: "toss_up_form_option_select_id",
      name: "選択肢",
      table: false,
      tableValue: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "list" as const,
      addMessage: "",
    },
  ];
  function setGetSubSubTableAddChatAppDepend(value: {
    name: string;
    row: dataDifine | null;
  }) {
    if (value.name !== "依存質問-選択肢追加") return;
    const chatAppId =
      value.row?.id != null ? String(value.row.id) : getSubSubTableName.key?.id;
    if (!chatAppId) return;
    setAddChatAppDependSelect({
      toss_up_form_chat_app_id: chatAppId,
      option_id: "",
      toss_up_form_option_select_id: "",
    });
    const tossUpFormId = getSubTableName.key.id;
    setIsLoading(true);
    if (tossUpFormId) {
      getTossUpFormOptionsForChatAppDepend(tossUpFormId).then(
        (
          list: {
            option_id: number;
            option_name: string;
            option_selects: { id: number; option_select: string }[];
          }[],
        ) => {
          setTossUpFormOptionsForChatAppDependFull(list);
          setOnChatAppDependSelectAddModal(true);
          setIsLoading(false);
        },
      );
    } else {
      setTossUpFormOptionsForChatAppDependFull([]);
      setOnChatAppDependSelectAddModal(true);
      setIsLoading(false);
    }
  }
  async function postAddChatAppDependSelect() {
    if (
      !addChatAppDependSelect.toss_up_form_chat_app_id ||
      !addChatAppDependSelect.toss_up_form_option_select_id
    )
      return;
    setOnChatAppDependSelectAddModal(false);
    setIsLoading(true);
    try {
      const res = await postTossUpFormChatAppDependSelect({
        ...addChatAppDependSelect,
        toss_up_form_option_select_id: Number(
          addChatAppDependSelect.toss_up_form_option_select_id,
        ),
      });
      if (res === "success") {
        getSubSubtableDataTossUpFormChatAppDependSelect();
        getSubtableDataChatApp();
        setAddChatAppDependSelect({
          toss_up_form_chat_app_id: "",
          option_id: "",
          toss_up_form_option_select_id: "",
        });
        setOnChatAppDependSelectAddModalResult("success");
      } else {
        setOnChatAppDependSelectAddModal(true);
        setOnChatAppDependSelectAddModalResult(
          res || "データの登録に失敗しました。",
        );
      }
    } finally {
      setIsLoading(false);
    }
  }

  const [deleteChatAppDependSelectInf, setDeleteChatAppDependSelectInf] =
    useState<{
      status: null | "loading" | "open" | "success" | "failed";
      key: { [key: string]: string };
      message: string;
    }>({ status: null, key: {}, message: "" });

  // データの削除
  const [deleteDataInf, setDeleteDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deleteData() {
    setDeleteDataInf({
      ...deleteDataInf,
      status: "loading",
    });
    const id = deleteDataInf.key.id;
    const responce = await deleteTossUpForm(id);
    if (responce == "success") {
      await getTableData(false);
      setDeleteDataInf({
        ...deleteDataInf,
        status: "success",
      });
    } else {
      setDeleteDataInf({
        ...deleteDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteDataInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteDataInf]);

  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[],
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        },
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // カテゴリ一覧
  const [categoryList, setCategoryList] = useState<
    { id: number; category_name: string }[]
  >([]);
  const [categoryNameList, setCategoryNameList] = useState([""]);
  async function getCategoryList() {
    const fetchData = await getSerchCategorys();
    if (fetchData === null) {
      setCategoryList([]);
    } else if (fetchData) {
      setCategoryList(
        fetchData.categorys as {
          id: number;
          category_name: string;
        }[],
      );
      let categoryNameList = [""];
      fetchData.categorys.map(
        (company: { id: number; category_name: string }) => {
          if (!categoryNameList.includes(company.category_name)) {
            categoryNameList.push(company.category_name);
          }
        },
      );
      setCategoryNameList(categoryNameList);
    }
  }

  // 商材一覧
  const [productList, setProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }[],
      );
      let productNameList = [""];
      fetchData.products.map(
        (company: {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }) => {
          if (!productNameList.includes(company.product_name)) {
            productNameList.push(company.product_name);
          }
        },
      );
      setProductNameList(productNameList);
    }
  }

  // パートナー一覧
  const [companyList, setCampanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [tossUpFormCompanyList, setTossUpFormCompanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [companyNameList, setCampanyNameList] = useState([""]);
  // パートナー一覧取得
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCampanyList([]);
    } else if (fetchData) {
      setCampanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[],
      );
      setTossUpFormCompanyList([
        { id: 0, sale_company_name: "デフォルト" },
        ...(fetchData.saleCompanys as {
          id: number;
          sale_company_name: string;
        }[]),
      ]);
      let companyNameList = ["", "デフォルト"];
      fetchData.saleCompanys.map(
        (company: { id: number; sale_company_name: string }) => {
          if (!companyNameList.includes(company.sale_company_name)) {
            companyNameList.push(company.sale_company_name);
          }
        },
      );
      setCampanyNameList(companyNameList);
    }
  }

  useEffect(() => {
    getHighRankCompanyList();
    getCategoryList();
    getProductList();
    getSaleCompanysList();
  }, []);

  // 排他制御: 検索とAIチャットは同時に開かない
  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open) setAiChatOpen(false);
  };
  const handleSetAiChatOpen = (open: boolean) => {
    setAiChatOpen(open);
    if (open) setSerchOpen(false);
  };

  return (
    <Box
      style={{
        width: isSmartPhone
          ? "calc(100% - 31px)"
          : (serchOpen || aiChatOpen)
            ? "calc(100% - 331px)"
            : "calc(100% - 31px)",
        height: isSmartPhone ? "calc(100vh - 120px)" : "calc(100vh - 40px)",
      }}
    >
      <TableTopBar
        serch={true}
        serchOpen={serchOpen}
        setSerchOpen={handleSetSerchOpen}
        addDataNames={addDataNames}
        addDataName={addDataName}
        setAddDataName={setAddDataName}
        addCSVDataNames={addCSVDataNames}
        addCSVDataName={addCSVDataName}
        setAddCSVDataName={setAddCSVDataName}
        getXLSXDataNames={getXLSXDataNames}
        getXLSXDataName={getXLSXDataName}
        setGetXLSXDataName={setGetXLSXDataName}
        editDatasNames={editDatasNames}
        editDatasName={editDatasName}
        setEditDatasName={setEditDatasName}
        editIDs={editFormsStatus.editIDs}
        columnSettingOpen={false}
        openColumnSettingWindow={() => {}}
        aiChatOpen={aiChatOpen}
        setAiChatOpen={handleSetAiChatOpen}
      />
      <Box style={{ display: "flex" }}>
        {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
          <Box
            style={{
              width: isSmartPhone ? undefined : "100%",
              margin: isSmartPhone ? undefined : "10px 15px",
              height: isSmartPhone ? undefined : tableHeight,
              maxHeight: isSmartPhone ? undefined : tableHeight,
            }}
          >
            <ConstTable
              getTableData={getTableData}
              tableType={"main"}
              serchOpen={serchOpen}
              aiChatOpen={aiChatOpen}
              tableHeight={tableHeight}
              tableColumn={tossUpFormTableColumn}
              dataColumn={[]}
              rows={fetchData}
              displayNumber={displayNumber}
              setDisplayNumber={setDisplayNumber}
              displayNumbers={displayNumbers}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              maxPageNumber={maxPageNumber}
              totalCount={totalCount}
              getDataDetail={getDataDetail}
              getSubTableName={getSubTableName}
              setGetSubTableName={setGetSubTableName}
              getSubTableDetail={getSubTableDetail}
              setGetSubTableDetail={setGetSubTableDetail}
              setGetSubTableAdd={setGetSubTableAdd}
              setGetSubTableEditDirect={() => {}}
              getSubSubTableName={getSubSubTableName}
              setGetSubSubTableName={setGetSubSubTableName}
              getSubSubTableDetail={getSubSubTableDetail}
              setGetSubSubTableDetail={setGetSubSubTableDetail}
              setGetSubSubTableAdd={setGetSubSubTableAddChatAppDepend}
              setGetSubSubTableEditDirect={() => {}}
              tableTitle={tossUpFormTableColumn.title}
              switchTableCheckBox={() => {}}
              allCheckFlg={false}
              switchAllTableCheckBox={() => {}}
              editIDs={editFormsStatus.editIDs}
              setEditIDs={(editIDs: number[]) => {
                setEditFormsStatus({
                  ...editFormsStatus,
                  editIDs,
                });
              }}
              setEditDatasName={setEditDatasName}
              setGetSubMainTableName={setGetSubMainTableName}
              setTableOriginalFunc={setTableOriginalFunc}
              sortColumn={[]}
              setSortColumn={() => {}}
            />
          </Box>
        )}
        {serchOpen ? (
          <SerchSideBar
            setSerchOpen={handleSetSerchOpen}
            tableHeight={tableHeight}
            tableColumn={tossUpFormTableColumn}
            dataColumn={[]}
            firstYear={firstYear}
            thisYear={thisYear}
            serchColumn={serchColumn}
            setSerchString={setSerchString}
            companyNameList={companyNameList}
            companyGroupNameList={[]}
            highRankCompanyNameList={highRankCompanyNameList}
            categoryNameList={[]}
            productNameList={productNameList}
            accountSaleNameList={[]}
            accountStaffNameList={[]}
            serchStringView={serchStringView}
            setSerchStringView={setSerchStringView}
          />
        ) : null}
        {aiChatOpen && (
          <AiChatSideBar
            open={aiChatOpen}
            setOpen={handleSetAiChatOpen}
            pageName="TossUpForm"
          />
        )}
        <DataDetailModal
          onModal={
            dataDetail !== null &&
            ((editData !== null && editData.status !== "editing") ||
              editData === null)
          }
          swCloseModal={() => setDataDetail(null)}
          detailTitle={tossUpFormTableColumn.detailTitle}
          editAuth={tossUpFormTableColumn.editAuth}
          dataColumn={tossUpFormTableColumn.dataColumn}
          subDataColumn={[]}
          dataDetail={dataDetail}
          setEditData={setEditData}
          option={false}
          setEditProduct={() => {}}
          dataDetailOption={[]}
          dataDetailOptionSelect={[]}
          dataDetailHistory={[]}
          selectHistory={0}
          getOldDataDetail={() => {}}
          getGroupList={() => {}}
          setEditProductOptionPlans={() => {}}
          setEditProductOptionContents={() => {}}
          setEditTossUpFormOptionProducts={() => {}}
          setEditOutsideServices={() => {}}
          setSelectServiseInfo={() => {}}
          setSelectTossUpInfo={() => {}}
        />
        <DataDetailModal
          onModal={
            dataDetailChatApp !== null &&
            ((editChatAppData !== null &&
              editChatAppData.status !== "editing") ||
              editChatAppData === null)
          }
          swCloseModal={() => {
            setDataDetailChatApp(null);
            setGetSubTableDetail({
              name: "",
              key: {},
              dataDetail: null,
            });
          }}
          detailTitle={"チャットアプリ連携詳細"}
          editAuth={tossUpFormTableColumn.editAuth}
          dataColumn={[]}
          subDataColumn={tossUpFormTableColumn.subTable[0].subDataColumn}
          dataDetail={dataDetailChatApp}
          setEditData={setEditChatAppData}
          option={false}
          setEditProduct={() => {}}
          dataDetailOption={[]}
          dataDetailOptionSelect={[]}
          dataDetailHistory={[]}
          selectHistory={0}
          getOldDataDetail={() => {}}
          getGroupList={() => {}}
          setEditProductOptionPlans={() => {}}
          setEditProductOptionContents={() => {}}
          setEditTossUpFormOptionProducts={() => {}}
          setEditOutsideServices={() => {}}
          setSelectServiseInfo={() => {}}
          setSelectTossUpInfo={() => {}}
        />
        <DataEditModal
          onModal={
            editChatAppData !== null && editChatAppData.status !== "editing"
          }
          swCloseModal={() => setEditChatAppData(null)}
          editData={editChatAppData}
          setEditData={setEditChatAppData}
          putEditData={putEditChatAppData}
          groupList={[]}
          categoryList={[]}
          accountCollaborateCompanySaleList={[]}
          selectServiseInfo={{
            service_plan_data: [],
            service_content_data: [],
            service_campaign_pulldown_data: [],
            service_campaign_checkbox_data: [],
          }}
          selectTossUpInfo={{
            tossUpCategoryNameList: [],
            tossUpProductNameList: [],
          }}
        />
        <DataEditModal
          onModal={editData !== null && editData.status !== "editing"}
          swCloseModal={() => setEditData(null)}
          editData={editData}
          setEditData={setEditData}
          putEditData={putEditData}
          groupList={[]}
          categoryList={[]}
          accountCollaborateCompanySaleList={[]}
          selectServiseInfo={{
            service_plan_data: [],
            service_content_data: [],
            service_campaign_pulldown_data: [],
            service_campaign_checkbox_data: [],
          }}
          selectTossUpInfo={{
            tossUpCategoryNameList: [],
            tossUpProductNameList: [],
          }}
        />
        <DataDetailModal
          onModal={
            dataDetailTossUpFormOptionsMain !== null &&
            ((editTossUpFormOption !== null &&
              editTossUpFormOption.status !== "editing") ||
              editTossUpFormOption === null)
          }
          swCloseModal={() => {
            setDataDetailTossUpFormOptionsMain(null);
            setGetSubMainTableName({
              name: "",
              key: {},
            });
          }}
          detailTitle={"質問一覧詳細"}
          editAuth={tossUpFormTableColumn.editAuth}
          dataColumn={[]}
          subDataColumn={[]}
          dataDetail={dataDetailTossUpFormOptionsMain}
          setEditData={() => {}}
          option={true}
          setEditProduct={setEditTossUpFormOption}
          dataDetailOption={[]}
          dataDetailOptionSelect={[]}
          dataDetailHistory={[]}
          selectHistory={0}
          getOldDataDetail={() => {}}
          getGroupList={() => {}}
          setEditProductOptionPlans={() => {}}
          setEditProductOptionContents={() => {}}
          setEditTossUpFormOptionProducts={setEditTossUpFormOptionProducts}
          setEditOutsideServices={() => {}}
          setSelectServiseInfo={() => {}}
          setSelectTossUpInfo={() => {}}
        />
        <DataAddModal
          onModal={onTossUpFormAddModal}
          swCloseModal={() => {
            setTossUpFormAddModal(false);
            setAddDataName("");
          }}
          addTitle={tossUpFormTableColumn.addTitle}
          dataColumn={tossUpFormTableColumn.dataColumn}
          subDataColumn={[]}
          postAddData={postAddTossUpForm}
          addData={addTossUpForm}
          setAddData={setAddTossUpForm}
          companyList={tossUpFormCompanyList}
          highRankCompanyList={highRankCompanyList}
          staffList={[]}
          firstYear={firstYear}
          thisYear={thisYear}
          productList={[]}
          categoryList={categoryList}
          groupList={[]}
          postFiles={{}}
          setPostFiles={() => {}}
          sitePathList={[]}
        />
        <DataAddModalResult
          onModal={onDataAddModalResult !== ""}
          swCloseModal={() => {
            setOnDataAddModalResult("");
            setAddDataName("");
          }}
          addModalTitle={"新規作成"}
          onDataAddModalResult={onDataAddModalResult}
        />
        <ProductEditModal
          onModal={
            editTossUpFormOption !== null &&
            editTossUpFormOption.status !== "editing"
          }
          swCloseModal={() => setEditTossUpFormOption(null)}
          editProduct={editTossUpFormOption}
          setEditProduct={setEditTossUpFormOption}
          putEditProduct={putEditTossUpFormOption}
          editProductOptionPlans={[]}
          editProductOptionContents={[]}
          editTossUpFormOptionProducts={editTossUpFormOptionProducts}
          editOutsideServices={[]}
        />
        <DataAddModalResult
          onModal={onSubtableDataAddModalResult !== ""}
          swCloseModal={() => {
            setOnSubtableDataAddModalResult("");
            setGetSubTableAdd({
              name: "",
              row: null,
            });
          }}
          addModalTitle={"新規作成"}
          onDataAddModalResult={onSubtableDataAddModalResult}
        />
        <PostCSVModal
          onModal={
            postTossUpFormOptionCSVStatus.status !== "none" &&
            postTossUpFormOptionCSVStatus.status !== "loading"
          }
          swCloseModal={() => {
            setPostTossUpFormOptionCSVStatus({
              status: "none",
              message: "",
              result: [],
              header_location: "None",
            });
            setAddCSVDataName("");
          }}
          postCSVStatus={postTossUpFormOptionCSVStatus}
          setPostCSVStatus={setPostTossUpFormOptionCSVStatus}
          postCSVFunc={postProductsCSV}
          postCSVTitle={"トスアップフォーム - 質問登録CSV取込"}
          postCSVColumn={postCSVColumnTossUpFormOption}
          postCSVColumnResult={postCSVColumnTossUpFormOptionResult}
          postCSVPath="tossUpFormOption"
          productList={[]}
          categoryList={[]}
        />
        <DataDeleteModal
          onModal={
            deleteDataInf.status !== null && deleteDataInf.status !== "loading"
          }
          swCloseModal={() => {
            setDeleteDataInf({
              status: null,
              key: {},
              message: "",
            });
            setTableOriginalFunc({
              name: "",
              key: {},
            });
          }}
          deleteDataInf={deleteDataInf}
          setDeleteDataInf={setDeleteDataInf}
          deleteData={deleteData}
          labels={{
            title: "トスアップフォーム削除",
            confirmBody: (
              <Alert severity="error">
                トスアップフォーム削除後、データは復元できません。
              </Alert>
            ),
            confirmButtonLabel: "トスアップフォーム削除",
            successMessage: "トスアップフォームの削除に成功しました。",
          }}
        />
        <DataAddModal
          onModal={onChatAppAddModal}
          swCloseModal={() => {
            setChatAppAddModal(false);
            setGetSubTableAdd({
              name: "",
              row: null,
            });
          }}
          addTitle={"チャットアプリ連携追加"}
          dataColumn={[]}
          subDataColumn={tossUpFormTableColumn.subTable[0].subDataColumn}
          postAddData={postAddChatApp}
          addData={addChatApp}
          setAddData={setAddChatApp}
          companyList={[]}
          highRankCompanyList={[]}
          staffList={[]}
          firstYear={firstYear}
          thisYear={thisYear}
          productList={[]}
          categoryList={[]}
          groupList={[]}
          postFiles={{}}
          setPostFiles={() => {}}
          sitePathList={[]}
        />
        <DataAddModalResult
          onModal={onChatAppAddModalResult !== ""}
          swCloseModal={() => {
            setOnChatAppAddModalResult("");
            setGetSubTableAdd({
              name: "",
              row: null,
            });
          }}
          addModalTitle={"チャットアプリ連携追加"}
          onDataAddModalResult={onChatAppAddModalResult}
        />
        <DataDeleteModal
          onModal={
            deleteChatAppInf.status !== null &&
            deleteChatAppInf.status !== "loading"
          }
          swCloseModal={() => {
            setDeleteChatAppInf({
              status: null,
              key: {},
              message: "",
            });
            setTableOriginalFunc({
              name: "",
              key: {},
            });
          }}
          deleteDataInf={deleteChatAppInf}
          setDeleteDataInf={setDeleteChatAppInf}
          deleteData={deleteChatAppData}
          labels={{
            title: "チャットアプリ連携削除",
            confirmBody: (
              <Alert severity="error">
                チャットアプリ連携削除後、データは復元できません。
              </Alert>
            ),
            confirmButtonLabel: "チャットアプリ連携削除",
            successMessage: "チャットアプリ連携の削除に成功しました。",
          }}
        />
        {/* チャット連携-依存質問-選択肢 追加 */}
        <DataAddModal
          onModal={onChatAppDependSelectAddModal}
          swCloseModal={() => {
            setOnChatAppDependSelectAddModal(false);
            setAddChatAppDependSelect({
              toss_up_form_chat_app_id: "",
              option_id: "",
              toss_up_form_option_select_id: "",
            });
          }}
          addTitle={
            tossUpFormTableColumn.subTable[0].subTable[0].subTableAddTitle
          }
          dataColumn={[]}
          subDataColumn={chatAppDependSelectAddSubDataColumn}
          postAddData={postAddChatAppDependSelect}
          addData={addChatAppDependSelect}
          setAddData={
            ((updater) => {
              setAddChatAppDependSelect((prev) => {
                const next = (
                  typeof updater === "function" ? updater({ ...prev }) : updater
                ) as {
                  toss_up_form_chat_app_id: string;
                  option_id: string;
                  toss_up_form_option_select_id: string;
                };
                if (
                  next.option_id !== undefined &&
                  next.option_id !== prev.option_id
                ) {
                  return { ...next, toss_up_form_option_select_id: "" };
                }
                return next;
              });
            }) as Dispatch<
              SetStateAction<{ [key: string]: string | boolean | any[] }>
            >
          }
          companyList={[]}
          highRankCompanyList={[]}
          staffList={[]}
          firstYear={firstYear}
          thisYear={thisYear}
          productList={[]}
          categoryList={[]}
          groupList={[]}
          postFiles={{}}
          setPostFiles={() => {}}
          sitePathList={[]}
          subDataColumnOptionList={{
            option_id: tossUpFormOptionsForChatAppDependFull.map((o) => ({
              id: o.option_id,
              name: o.option_name,
            })),
          }}
          subDataColumnOptionListByKey={(key, addData) => {
            if (key !== "toss_up_form_option_select_id") return undefined;
            const opt = tossUpFormOptionsForChatAppDependFull.find(
              (o) => String(o.option_id) === String(addData.option_id),
            );
            return opt
              ? opt.option_selects.map((s) => ({
                  id: s.id,
                  name: s.option_select,
                }))
              : [];
          }}
        />
        <DataAddModalResult
          onModal={onChatAppDependSelectAddModalResult !== ""}
          swCloseModal={() => {
            setOnChatAppDependSelectAddModalResult("");
          }}
          addModalTitle={
            tossUpFormTableColumn.subTable[0].subTable[0].subTableAddTitle
          }
          onDataAddModalResult={onChatAppDependSelectAddModalResult}
        />
        {/* チャット連携-依存質問-選択肢 削除 */}
        <DataDeleteModal
          onModal={
            deleteChatAppDependSelectInf.status !== null &&
            deleteChatAppDependSelectInf.status !== "loading"
          }
          swCloseModal={() => {
            setDeleteChatAppDependSelectInf({
              status: null,
              key: {},
              message: "",
            });
            setTableOriginalFunc({ name: "", key: {} });
          }}
          deleteDataInf={deleteChatAppDependSelectInf}
          setDeleteDataInf={setDeleteChatAppDependSelectInf}
          deleteData={async () => {
            setDeleteChatAppDependSelectInf({
              ...deleteChatAppDependSelectInf,
              status: "loading",
            });
            setIsLoading(true);
            try {
              const id = deleteChatAppDependSelectInf.key.id;
              const res = await deleteTossUpFormChatAppDependSelect(id);
              if (res === "success") {
                getSubSubtableDataTossUpFormChatAppDependSelect();
                getSubtableDataChatApp();
                setDeleteChatAppDependSelectInf({
                  status: "success",
                  key: {},
                  message: "",
                });
              } else {
                setDeleteChatAppDependSelectInf({
                  status: "failed",
                  key: {},
                  message: res || "",
                });
              }
            } finally {
              setIsLoading(false);
            }
          }}
          labels={{
            title: "依存質問-選択肢削除",
            confirmBody: (
              <Alert severity="error">削除後、データは復元できません。</Alert>
            ),
            confirmButtonLabel: "削除",
            successMessage: "削除に成功しました。",
          }}
        />
        <FormOptionsEditModal
          onModal={
            editFormsStatus.status !== "none" &&
            editFormsStatus.status !== "loading"
          }
          swCloseModal={() => {
            setEditFormsStatus({
              status: "none",
              message: "",
              editIDs: [],
              action: null,
              delete_option_names: [],
              select_option: {
                option_name: "",
                outside_form_display: 0,
                sns_send: 1,
                required_optional: 0,
                option_type: 0,
                option_default_value: "",
                change_value_conf: 0,
                option_comment: "",
                tel_flg: 0,
                name_flg: 0,
                company_name_flg: 0,
                zip_code_flg: 0,
                address_flg: 0,
                space_flg: 0,
                mail_address_flg: 0,
                form_tel_flg: 0,
                multi_text_flg: 0,
                contract_number_flg: 0,
                half_width_number_flg: 0,
                option_select: [""],
              },
            });
            setEditFormOptionNames([]);
            setEditDatasName("");
          }}
          backSwCloseModal={() => {
            setEditFormsStatus({
              ...editFormsStatus,
              status: "none",
              message: "",
              action: null,
            });
            setEditFormOptionNames([]);
            setEditDatasName("");
          }}
          editFormsStatus={editFormsStatus}
          setEditFormsStatus={setEditFormsStatus}
          getEditFormDeleteOptionNames={getEditFormDeleteOptionNames}
          editFormOptionNames={editFormOptionNames}
          postEditFormOption={postEditFormOption}
          deleteEditFormOption={deleteEditFormOption}
        />
      </Box>
    </Box>
  );
}

export default TossUpForm;
